var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { observe } from 'selector-observer';
import { EventStrategy } from './EventStrategy';
var triggerDOMEventMap = new Map([
    ['ElementClick', 'click'],
    ['ElementMouseOver', 'mouseover']
]);
/**
 * ElementEvents handles events fired off by a DOM element.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Element#events
 */
var ElementEventStrategy = /** @class */ (function (_super) {
    __extends(ElementEventStrategy, _super);
    function ElementEventStrategy(context, props) {
        var _this = _super.call(this, context, props) || this;
        _this.handleElementEvent = function (event) {
            var _a;
            //TODO: event.preventDefault(); and event.preventPropagation(); here when needed to stop default behavior
            if (_this.props.preventDefault) {
                event.preventDefault();
            }
            (_a = _this.onEventTriggered) === null || _a === void 0 ? void 0 : _a.call(_this, {
                condition: true,
                props: _this.props,
                data: event
            });
        };
        var domEvent = triggerDOMEventMap.get(_this.props.event);
        if (!domEvent) {
            throw Error("eventType does not map to any DOM element event: ".concat(_this.props.event));
        }
        _this.domEvent = domEvent;
        return _this;
    }
    ElementEventStrategy.prototype.start = function () {
        var _this = this;
        var props = this.props;
        observe(props.cssSelector, {
            add: function (el) {
                el.addEventListener(_this.domEvent, _this.handleElementEvent);
            },
            remove: function (el) {
                el.removeEventListener(_this.domEvent, _this.handleElementEvent);
            }
        });
    };
    return ElementEventStrategy;
}(EventStrategy));
export { ElementEventStrategy };
//# sourceMappingURL=ElementEventStrategy.js.map